import React from 'react';
import LogsCardShimmer from './LogsCardShimmer';

export interface LogsCardsListShimmerProps {
  count?: number;
  withLeadingContent?: boolean;
}

const LogsCardsListShimmer: React.FC<LogsCardsListShimmerProps> = ({
  count = 3,
  withLeadingContent = false,
}) => (
  <>
    {Array.from({ length: count }, (_, index) => (
      <LogsCardShimmer key={`logs-card-shimmer-${index}`} withLeadingContent={withLeadingContent} />
    ))}
  </>
);

export default LogsCardsListShimmer;
